import React from "react";
import { ReactElement } from "react";
import { Download } from "react-bootstrap-icons";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";

import "./ReportTypeCard.scss";

interface Props<TypeReportTypeCard> {
  title: string;
  description: string;
  navigateTo: () => void;
}

export default function ReportTypeCard<TypeReportTypeCard>({
  title,
  description,
  navigateTo,
}: Props<TypeReportTypeCard>): ReactElement {
  return (
    <div className="report-type-card" onClick={navigateTo}>
      <div className="title">
        <div>{title}</div> <i className=""><Download/></i>
      </div>
      <div className="details">{description}</div>
    </div>
  );
}
